import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Modal from "../../components/Modal/Modal";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import { SubmitButton } from "../../components/buttons";
import OpenDocuments from "../../helpers/openDocument";
import { StyledTableRow } from "helpers/CustomMenu";
import { BorderColor, Info } from "@mui/icons-material";
import StatusLayout from "components/Status";
import AddModal from "components/ActionTracking/AddModal";
import axios from "axios";

const MinutesDetails = (props) => {
  const {
    location,
    selectedUsers,
    onSelectUser,
    howToShare,
    setHowToShare,
    removeUser,
    content,
    setContent,
    setSubject,
    GeneralDownload,
    subject,
    loggedUser,
    message,
    loading,
    onSubmit,
    minutesDetails,
    GetEmployees,
    resources,
    onSubmitAction,
    systemSettings
  } = props;
  const mainBackground = systemSettings?.mainBackground;

  const [share, setShare] = useState(false);
  const [email, setEmail] = React.useState("");
  const [confirm, setConfirm] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [type, setType] = useState('')
  const [editInfo, setEditInfo] = useState({})
  const [select, setSelect] = useState(false);
  const [meetingInfo, setMeetingInfo] = useState(null);
  const [meeting, setMeeting] = useState(null);

  const meetingId = props.minutesDetails?.meetingId;

  let isCreator = location?.state?.creator === loggedUser?.userId;
  let history = useHistory();
  // const meeting = location?.state?.meeting;
  const meetingAction = minutesDetails?.MeetingActions

  const fetchMeetingDetails = async () => {
    const response = await axios.get(`api/meeting/${meetingId}`);
    if (response.status) {
      setMeetingInfo(response.data?.meeting);
      setMeeting(response.data?.meeting);
    } else {
      console.error("Error fetching meeting details:", response.statusText);
    }
  }

//   useEffect(() => {
//   console.log("Updated selectedUsers:", selectedUsers);
// }, [selectedUsers]);

  useEffect(() => {
    if (meetingId) {

      fetchMeetingDetails();
    }
  }
    , [meetingId]);
  return (
    <div>
      <Card>
        <CardHeader
          title={<span className="text-capitalize">Minutes</span>}
          subheader={
            <div>
              <div>
                Created At :{" "}
                {moment(location.state?.createdAt).format("DD/MM/yyyy")}
              </div>
              <div>Meeting: {meeting?.name}</div>
            </div>

          }
          titleTypographyProps={{ variant: "h6" }}
        />
        <CardContent>
          {/* list of actions */}

          {meetingAction?.length ?
            <>
              <Typography variant="h5">Activities </Typography>
              <TableContainer className="mb-3" title="actions">
                <Table size={"small"}>
                  <TableHead className="fw-bold">
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Days left</TableCell>
                      <TableCell>Responsible</TableCell>
                      <TableCell>Report To</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {meetingAction?.map((item, index) => {
                      const days = moment(item?.endDate).diff(moment(), 'days')

                      return <StyledTableRow >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item?.name}</TableCell>
                        <TableCell className={days > 0 ? "text-green-700" : 'text-blue-700'}>{days}</TableCell>
                        {/* <TableCell>{moment(item?.startDate).format("DD/MM/yyyy")}</TableCell> */}
                        {/* <TableCell>{moment(item?.endDate).format("DD/MM/yyyy")}</TableCell> */}
                        <TableCell>{item?.responsible?.names}</TableCell>
                        <TableCell>{item?.report?.names}</TableCell>
                        <TableCell><StatusLayout status={item?.status} /></TableCell>
                        <TableCell>
                          <Button
                            startIcon={<Info />}
                            style={{ color:mainBackground }}
                            onClick={() => {
                              history.push(`/admin/action/details/${item?.id}`);
                            }}
                          >
                            Details
                          </Button>
                          <Button
                            style={{ color:mainBackground }}
                            startIcon={<BorderColor />}
                            onClick={() => {
                              setSelect(true)
                              setEditInfo({ ...item, endDate: moment(item?.endDate).format('YYYY-MM-DD'), startDate: moment(item?.startDate).format('YYYY-MM-DD') })
                            }}
                          >
                            Edit
                          </Button>
                        </TableCell>
                      </StyledTableRow>
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
            : null}

          {/* <CardContent> */}
          <div className={"row mb-3"}>
            <OpenDocuments
              mimeType={"application/pdf"}
              document={minutesDetails?.attachment}
              downloadable={false}
              type={"minutes"}
            />
          </div>

        </CardContent>
        <CardActions className={"float-end"}>
          <Button
            style={{ color:mainBackground }}
            onClick={() => history.goBack()}>Go Back</Button>
          {isCreator && (
            <Button
              style={{ color:mainBackground }}
              className="text-info" onClick={() => setShare(true)}>
              Share
            </Button>
          )}
          {location?.state?.Minutes?.content !== null ? (
            downloading ? <CircularProgress size={30} /> : <Button
              color={"success"}
              onClick={async () => {
                setDownloading(true);
                await GeneralDownload(minutesDetails?.attachment, "minutes", minutesDetails?.attachment);
                setDownloading(false);
              }}>
              Download
            </Button>
          ) : (downloading ? <CircularProgress size={30} /> :
            <Button
              color={"secondary"}
              onClick={async () => {
                setDownloading(true);
                await GeneralDownload(location?.state?.Minutes?.id, "minutes", location?.state?.Minutes?.attachment);
                setDownloading(false);
              }}
            >
              Download
            </Button>
          )}
        </CardActions>
      </Card>

      <Modal select={share} setSelect={setShare} title={"Share Minutes"}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setConfirm(true);
          }}
        >
          <div className="row justify-content-center mb-4">
            <div className="col-md-6 ">
              <span className="text-center text-danger fw-bolder">
                {message}
              </span>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-11 ">
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label fw-bold text-capitalize">
                  Subject
                </label>
                <div className="col-md-10">
                  <input
                    type="text"
                    className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    value={subject}
                    required={true}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label fw-bold text-capitalize">
                  Share To
                </label>
                <div className="col-md-10">
                  <select
                    value={howToShare}
                    className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                 
                    onChange={(e) => {
                      setHowToShare(e.target.value);
                      if (
                        e.target.value === "All Participants" &&
                        meetingInfo?.MeetingParticipants
                      ) {
                        const emails = meetingInfo.MeetingParticipants.map((p) => p.email);
                        props.setSelectedUsers(emails);
                      }
                      if (e.target.value === "Specific") {
                        props.setSelectedUsers([]);
                      }
                      // This will always log the previous value, not the new one!
                      // console.log("Target value is: ", selectedUsers);
                    }}
                  >
                    <option>select</option>
                    {["All Participants", "Specific"].map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {howToShare === "Specific" && (
                <>
                  <div className="mb-3 row">
                    <div className="col-2 " />
                    <div className="col-7">
                      <input
                        type="email"
                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="col-3 ">
                      <Button
                        onClick={() => {
                          if (email.trim() !== "") {
                            onSelectUser(email);
                            setEmail("");
                          }
                        }}
                      >
                        <i className="fa fa-plus me-1" /> Add Email
                      </Button>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <div className="col-2" />
                    <div className="col bg-grey rounded">
                      {selectedUsers?.map((shareTo) => (
                        <div key={shareTo} className="btn-group bg-light p-2 border">
                          <label className="me-1">{shareTo}</label>
                          <button
                            type="button"
                            className="btn-close btn-sm"
                            onClick={() => removeUser(shareTo)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label fw-bold text-capitalize">
                  Email Content
                </label>
                <div className="col">
                  <JoditEditorExample
                    htmlContent={content}
                    onBlur={(str) => setContent(str.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <DialogActions>
            <Button
              color="error"
              onClick={() => {
                setShare(false);
              }}
            >
              Cancel
            </Button>
            {loading ? (
              <CircularProgress />
            ) : (
              <SubmitButton
                name="SEND"
                handleAction={() => onSubmit()}
                confirm={confirm}
                setConfirm={setConfirm}
              />
            )}
          </DialogActions>
        </form>
      </Modal>

      <AddModal setType={setType}
        setInfo={setEditInfo}
        info={editInfo}
        type={type}
        // setListOfAction={setListOfAction}
        resources={resources}
        GetEmployees={GetEmployees}
        setSelect={setSelect}
        select={select}
        loading={loading}
        needDirectSubmit={true}
        onSubmit={onSubmitAction}
        systemSettings={systemSettings}
      />
    </div>
  );
};
export default MinutesDetails;
